<template>
  <!-- <transition
    @enter="animateIn"
    @leave="animateOut"
  > -->
    <div class="home-view view">
      <div class="home-content-view content-view">
        <div class="hv-gummies">
          <div class="hv-mer-bear"></div>
          <div class="hv-uni-shark"></div>
        </div>

        <Button
          :class="'start-btn'"
          :label="'START'"
          @clicked="handleStartBtnClicked"
        />

      </div>
    </div>
  <!-- </transition> -->
</template>

<script>
// @ is an alias to /src
import { ref, computed, watch, onMounted, onBeforeUnmount, onUnmounted } from '@vue/composition-api';
import gsap from 'gsap';

import Button from '@/components/Button';


const NAMESPACE = '[Home]';

export default {
  name: 'Home',
  components: {
    Button,
  },

  // methods: {
  //   beforeEnter(el) {
  //     console.log(NAMESPACE, 'beforeEnter');
  //   },
  //
  //   beforeLeave(el) {
  //     console.log(NAMESPACE, 'beforeLeave');
  //   },
  // },

  setup(props, context) {
    const {
      $router,
      $store
    } = context.root;

    console.log(NAMESPACE, 'setup()');

    // Properties

    /**
     * Vue Hooks
     */
    onMounted(() => {
      console.log(NAMESPACE, 'onMounted()');

      console.log(context.root.beforeLeave);
    });

    onBeforeUnmount(() => {
      console.log(NAMESPACE, 'onBeforeUnmount()');
      console.log(new Date());
    })

    onUnmounted(() => {
      console.log(NAMESPACE, 'onUnmounted()');
      console.log(new Date());
    })

    /**
     * Methods
     */
    const handleStartBtnClicked = () => {
      $router.push({path:'/quiz'});
    }


    /**
     * Animation
     */
    // const beforeEnter = (el) => {
    //
    // }

    const animateIn = (el, done) => {
      console.log(NAMESPACE, 'animateIn()');

      let timelineIn = gsap.timeline({paused:true});

      done();
    }

    const animateOut = (el, done) => {
      console.log(NAMESPACE, 'animateOut()');

      let timelineOut = gsap.timeline({paused:true});

      // timelineOut.

      done();
    }


    return {
      handleStartBtnClicked,

      // beforeEnter,
      animateIn,
      animateOut,
    }
  },
}
</script>


<style lang="scss" scoped>

.home-view {

}

.home-content-view {
  // position: relative;
  // width: 60%;
  // max-width: 800px;
  // min-height: calc(var(--vh, 1vh) * 100 - 0vh);
  height: calc(#{$min-height});
}

.hv-gummies {
  position: absolute;
  top: 18%;
  left: 15%;
  width: 70%;
  height: 82%;
}

.hv-mer-bear {
  position: absolute;
  // top: 23%;
  // width: 96%;
  // left: 2%;
  top: 0;
  left: 0;
  width: 100%;
  background-image: url('~@/assets/images/landing_merbear.png');
  background-size: cover;
  background-repeat: no-repeat;

  @include bg-image(1037, 822);

  // &::before {
  //   content: '';
  //   display: block;
  //   width: 100%;
  //   padding-top: calc(822 / 1037 * 100%);
  // }
}

.hv-uni-shark {
  position: absolute;
  // top: 49%;
  // width: 96%;
  // left: 2%;
  top: 29%;
  left: 0;
  width: 100%;
  background-image: url('~@/assets/images/landing_unishark.png');
  background-size: cover;
  background-repeat: no-repeat;
  @include bg-image(1041, 883);

  // &::before {
  //   content: '';
  //   display: block;
  //   width: 100%;
  //   padding-top: calc(883 / 1041 * 100%);
  // }
}

.start-btn {
  position: absolute;
  bottom: 2.5rem;
  left: 50%;
  transform: translateX(-50%);
}

@include height-medium {

}

@include height-short {

}

@include mobile {
  .home-content-view {
    height: initial;
    min-height: calc(var(--vh, 1vh) * 100 - 0vh);
  }

  .hv-gummies {
    top: 19%;
    left: 15%;
    width: 70%;
    // left: 10%;
    // width: 80%;
    height: 81%;
  }

  .hv-uni-shark {
    top: 31%;
  }

  // .hv-mer-bear {
  //   width: 80%;
  //   left: 10%;
  //   top: 19%;
  // }
  //
  // .hv-uni-shark {
  //   width: 80%;
  //   left: 10%;
  //   top: 46%;
  // }
}

// @include mobile-medium {
//
// }

@include mobile-small {
  .hv-gummies {
    top: 19%;
    left: 15%;
    width: 70%;
    height: 81%;
  }

  // .hv-mer-bear {
  //   width: 80%;
  //   left: 10%;
  //   top: 19%;
  // }
  //
  // .hv-uni-shark {
  //   width: 80%;
  //   left: 10%;
  //   top: 46%;
  // }

  .start-btn {
    bottom: 3rem;
  }
}

body.touch {
  @include height-medium {

  }

  @include height-short {
    .hv-gummies {
      top: 19%;
      left: 20%;
      width: 60%;
    }
  }

  @include mobile-aspect-ratio-40-62 {
    .hv-gummies {
      width: 58%;
      left: 21%;
    }
  }

  @include mobile-aspect-ratio-40-59 {
    .hv-gummies {
      top: 19%;
      width: 54%;
      left: 23%;
    }
  }
}
</style>
